<h1 mat-dialog-title>Gericht erstellen</h1>

<div mat-dialog-content>

  <form [formGroup]="addDishForm">

    <mat-form-field>
      <mat-label>Name</mat-label>
      <input matInput type="text" formControlName="name">
      <mat-error *ngIf="addDishForm.get('name').hasError('required')">Ein Name ist erforderlich</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Preis</mat-label>
      <input type="number" matInput formControlName="price" step="0.1">
      <mat-hint>Wert in €</mat-hint>
      <mat-error *ngIf="addDishForm.get('price').hasError('required')">Die Preis ist erforderlich</mat-error>
      <mat-error *ngIf="addDishForm.get('price').hasError('min')">Der Preis darf nicht unter 0 sein</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Beschreibung</mat-label>
      <textarea type="text" matInput formControlName="description"></textarea>
    </mat-form-field>

    <mat-form-field>
      <input matInput type="text" style="display: none;">
      <label for="image" class="select-image-btn">
        <mat-icon>insert_photo</mat-icon>
        Anzeigebild<span *ngIf='!image'> auswählen</span><span *ngIf='image'>:
        {{image.name}}</span>
      </label>
      <input type="file" style="visibility:hidden;" id="image" data-buttonText="Bild auswählen"
             (change)="imageUpload($event)">
    </mat-form-field>

    <mat-checkbox class="vegetarian-cbx" formControlName="vegetarian">Gericht ist vegetarisch</mat-checkbox>

    <mat-checkbox class="vegetarian-cbx" formControlName="special">Special</mat-checkbox>

    <mat-checkbox class="vegetarian-cbx" formControlName="low_carb">Low Carb</mat-checkbox>
  </form>

  <h3>Allergene auswählen</h3>

  <section class="allergen-cbx" *ngIf="allergensCbx">
    <mat-checkbox *ngFor="let a of allergensCbx" [(ngModel)]="a.checked">{{a.allergen.name}}</mat-checkbox>
  </section>

</div>

<div mat-dialog-actions>

  <button mat-button [mat-dialog-close]="false">Abbrechen</button>
  <button mat-stroked-button (click)="add()" [disabled]="addDishForm.invalid" cdkFocusInitial>Erstellen</button>

</div>
